import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapInvoiceDetails } from "@/redux/mappers/Export/CreateNewJob/Product/ProductMain/ProductGeneralMapper";
import { mapESanchitDetails } from "@/redux/mappers/Export/CreateNewJob/eSanchitMappers";
import { useParams } from "react-router";

export const eSanchitApi = createApi({
  reducerPath: "eSanchitApi",
  baseQuery,
  tagTypes: ["eSanchit"],
  endpoints: (builder) => ({
    getESanchitByMasterId: builder.query({
      query: ({ id }) => `export/eSanchit/${id}`,
      transformResponse: (response) => {
        return response?.data?.map(mapESanchitDetails) ?? [];
      },
      providesTags: ["eSanchit"],
    }),

    getExportInvoice: builder.query({
      query: ({ id }) => `export/invoice/main/${id}`,
      transformResponse: (response) => {
        return response?.data?.invoices?.map(mapInvoiceDetails) ?? [];
      },
      providesTags: ["Invoice"],
    }),

    updateESanchit: builder.mutation({
      query: ({ id, subId, ...data }) => {
        return {
          url: `export/eSanchit/${id}/${subId}`,
          method: "PUT",
          body: { eSanchit: data },
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
        };
      },
      invalidatesTags: ["eSanchit"],
    }),

    deleteESanchit: builder.mutation({
      query: ({ id }) => ({
        url: `export/eSanchit/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["eSanchit"],
    }),

    createESanchit: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/eSanchit/${id}`,
        method: "PUT",
        body: { eSanchit: data },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["eSanchit"],
    }),

    getFilterESanchit: builder.query({
      query: ({ id, data }) => {
        return `export/eSanchit/${id}?${data}`;
      },
      transformResponse: (response) => {
        return response?.data?.map(mapESanchitDetails) ?? [];
      },
      providesTags: ["eSanchit"],
    }),
  }),
});

export const {
  useLazyGetESanchitByMasterIdQuery,
  useUpdateESanchitMutation,
  useDeleteESanchitMutation,
  useCreateESanchitMutation,
  useGetExportInvoiceQuery,
  useLazyGetFilterESanchitQuery,
} = eSanchitApi;
